import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Skeleton,
  Typography
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import React from "react";
import { ModalLogShowFC } from "./types";
import useModal from "./useModal";

const ModalLogShow: ModalLogShowFC = () => {
  const {
    isOpen,
    isLoading,
    title,
    log,
    handlerClose,
    handlerCopy,
    handlerDownload,
  } = useModal();
  return (
    <Dialog open={isOpen} fullWidth maxWidth={"md"} onClose={handlerClose}>
      <DialogTitle>
        <Typography variant={"h3"}>
          {isLoading ? <Skeleton /> : title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography
            variant={"body2"}
            sx={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
          >
            {isLoading ? (
              <>
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </>
            ) : (
              log
            )}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} onClick={handlerCopy}>
          {"Скопировать"}
        </Button>
        <Button disabled={isLoading} onClick={handlerDownload}>
          {"Скачать"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalLogShow;
